module.exports = __webpack_public_path__ + "static/media/bishopMode.3cfd556a.gif";